import { render, staticRenderFns } from "./layout_empty.vue?vue&type=template&id=b3cb5918&"
import script from "./layout_empty.vue?vue&type=script&lang=js&"
export * from "./layout_empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports